import { render, staticRenderFns } from "./TransactionsGraph.vue?vue&type=template&id=b4dbf822&"
import script from "./TransactionsGraph.vue?vue&type=script&lang=js&"
export * from "./TransactionsGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports